module.exports = __webpack_public_path__ + "assets/img/img318.837b783b.png";